import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import Tag from './tag'

import styles from './tag-wrapper.module.css'

const propTypes = {
    numItems: PropTypes.number,
    tagClassName: PropTypes.string
}

const defaultProps = {
    numItems: 0
}

function PlusTag({ numItems, tagClassName, ...restProps }) {
    return (
        <Tag className={cx(styles['plus-tag'], tagClassName, 't3sel-tag-wrapper-plus-tag')} {...restProps}>
            {`+ ${numItems}`}
        </Tag>
    )
}

PlusTag.propTypes = propTypes
PlusTag.defaultProps = defaultProps

export { PlusTag }
